import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionModal } from '@/components/ui/modals/SelectionModal';


export interface NewAbsenceModalProps {
  onSelectMedicalLeave: () => void;
  onSelectPermits: () => void;
  onSelectVacations: () => void;
}

export const NewAbsenceModal: React.FC<NewAbsenceModalProps> = ({
  onSelectMedicalLeave,
  onSelectPermits,
  onSelectVacations,
}) => {
  const { t: translate } = useTranslation('absence');

  return (
    <SelectionModal
      data-testid="new-absence-modal"
      testIdPrefix="new-absence"
      title={translate('medicalLeave.modal.title')}
      subtitle={translate('medicalLeave.modal.subtitle')}
      options={[
        {
          title: translate('medicalLeave.modal.options.medicalLeave.title'),
          description: translate('medicalLeave.modal.options.medicalLeave.description'),
          onClick: onSelectMedicalLeave,
        },
        {
          title: translate('medicalLeave.modal.options.permissions.title'),
          description: translate('medicalLeave.modal.options.permissions.description'),
          onClick: onSelectPermits,
        },
        {
          title: translate('medicalLeave.modal.options.vacations.title'),
          description: translate('medicalLeave.modal.options.vacations.description'),
          onClick: onSelectVacations,
        },
      ]}
    />
  );
};

export default NewAbsenceModal;
